import { render, staticRenderFns } from "./ProductHeader.vue?vue&type=template&id=e77c9c3a&scoped=true"
import script from "./ProductHeader.vue?vue&type=script&lang=js"
export * from "./ProductHeader.vue?vue&type=script&lang=js"
import style0 from "./ProductHeader.vue?vue&type=style&index=0&id=e77c9c3a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e77c9c3a",
  null
  
)

export default component.exports